import { ScheduleException } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/exception.pb';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { BaseEventTooltip } from '@frontend/calendar-grid';
import { i18next, useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';

dayjs.extend(customParseFormat);

const formatExceptionTimeRange = (exception: ScheduleException) => {
  const startTime = exception.nextOccurrenceStart?.slice(11, 16) || exception.time?.startTime;
  const endTime = exception.time?.endTime;

  if (!startTime || !endTime) return i18next.t('All day', { ns: 'schedule' });

  return `${dayjs(startTime, 'HH:mm').format('h:mm A')} - ${dayjs(endTime, 'HH:mm').format('h:mm A')}`;
};

export const MultiExceptionTooltip = ({ exceptions }: { exceptions: ScheduleException[] }) => {
  const { t } = useTranslation('schedule');
  return (
    <BaseEventTooltip>
      <Text size='small' color='subdued'>
        {t('{{count}} Calendar Exceptions:', { count: exceptions.length })}
      </Text>
      <BaseEventTooltip.RowList>
        {exceptions.map((exception, index) => (
          <BaseEventTooltip.Row
            key={`${exception.id ?? exception.name ?? 'exception'}-${index}`}
            label={exception.name ?? ''}
            value={formatExceptionTimeRange(exception)}
          />
        ))}
      </BaseEventTooltip.RowList>
    </BaseEventTooltip>
  );
};

// single exception (not split by an overlap) — shows the exception's own time range instead of
// the grid segment's possibly-clipped startTime/duration
export const GridExceptionTooltip = ({ exception }: { exception: ScheduleException }) => (
  <BaseEventTooltip>
    <BaseEventTooltip.Text isPrimary isTruncated>
      {exception.name ?? ''}
    </BaseEventTooltip.Text>
    <BaseEventTooltip.Text>{formatExceptionTimeRange(exception)}</BaseEventTooltip.Text>
  </BaseEventTooltip>
);
